import { createMutation } from '@tanstack/svelte-query';
import { createZone, deleteZone, updateZone } from '$lib/api/zone';
import {
	invalidateAfterZoneCreate,
	invalidateAfterZoneDelete
} from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { ZoneRequest, ZoneResponse } from '$lib/types/zone';

export const createZoneMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<ZoneResponse, Error, ZoneRequest>(() => ({
		mutationFn: (request) => createZone(request),
		onSuccess: () => invalidateAfterZoneCreate(resolveScope(scope))
	}));

export const updateZoneMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<ZoneResponse, Error, { id: number; request: ZoneRequest }>(() => ({
		mutationFn: ({ id, request }) => updateZone(id, request),
		onSuccess: () => invalidateAfterZoneCreate(resolveScope(scope))
	}));

export const deleteZoneMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<void, Error, number>(() => ({
		mutationFn: (id) => deleteZone(id),
		onSuccess: () => invalidateAfterZoneDelete(resolveScope(scope))
	}));
